import React from 'react'

interface ExpandProps {
  size?: number
  color?: string
}

export const Expand: React.FC<ExpandProps> = ({
  size = 15,
  color = '#00DB4B',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.344 1.994h2.07L8.68 4.727a.45.45 0 000 .636l.456.456a.45.45 0 00.636 0l2.733-2.732v2.069c0 .248.201.45.45.45h.644a.45.45 0 00.45-.45V.9a.45.45 0 00-.45-.45H9.344a.45.45 0 00-.45.45v.644c0 .249.202.45.45.45zM1.4 8.394a.45.45 0 00-.45.45V13.1c0 .248.201.45.45.45h4.256a.45.45 0 00.45-.45v-.644a.45.45 0 00-.45-.45h-2.07L6.32 9.273a.45.45 0 000-.636l-.456-.456a.45.45 0 00-.636 0l-2.733 2.733v-2.07a.45.45 0 00-.45-.45H1.4z"
        fill="#FCFCFC"
        stroke={color}
        strokeWidth={0.1}
      />
    </svg>
  )
}
